export default "data:font/woff2;base64,"